<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">{{"View Document" | translate}}</h5>
        <div class="edit-icons" mat-dialog-close="">
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content d-flex flex-column justify-content-center pt-3 pt-lg-4">
        <iframe *ngIf="this.imagePath" [src]="sanitizer.bypassSecurityTrustResourceUrl(this.imagePath)" width="100%"  height="100%"></iframe>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>